// Contains the result of the intersection of two ICurves.
export class IntersectionInfo {
    // the constructor
    constructor(pr0, pr1, x, s0, s1) {
        this.par0 = pr0;
        this.par1 = pr1;
        this.x = x;
        this.seg0 = s0;
        this.seg1 = s1;
        /*Assert.assert(
          Point.close(x, s0.value(pr0), GeomConstants.intersectionEpsilon * 10),
        )*/
        //,
        //  String.format(
        //    'intersection not at curve[param]; x = {0}, s0[pr0] = {1}, diff = {2}',
        //    x,
        //    s0.value(pr0),
        //    x.sub(s0.value(pr0)),
        //  ),
        // )
        /*Assert.assert(
          Point.close(x, s1.value(pr1), GeomConstants.intersectionEpsilon * 10),
        )*/
        //,
        //  String.format(
        //    'intersection not at curve[param]; x = {1}, s1[pr1] = {1}, diff = {2}',
        //    x,
        //    s1.value(pr1),
        //    x.sub(s1.value(pr1)),
        //  ),
        // )
    }
}
//# sourceMappingURL=intersectionInfo.js.map